import {Component, OnInit, Input} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {ApiService} from "../../../services/api.service";
import {SearchService} from "../services/search.service";
import {NonprofitsDonorsDetailsSearchDto} from "../../../models/nonprofits-donors-details-search-dto";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-nonprofits-donors-details',
  templateUrl: './nonprofits-donors-details.component.html',
  styleUrls: ['./nonprofits-donors-details.component.scss'],
  standalone: false
})
export class NonprofitsDonorsDetailsComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: '/app/home'},
    { label: 'Home', path: 'app/home'},
    { label: 'Your Dashboard', path: 'app/users/dashboard'},
    { label: 'Search Nonprofits / Donors', path: 'app/search/nonprofits'},
    { label: 'View Nonprofits / Donors Details'}
  ]

  @Input()
  row: any;

  companyName = '';

  nonprofitDonorFullAttr: any = {};

  companyFinancialsByYear: any[] = [];

  constructor(private authService: AuthService, private apiService: ApiService, private searchService: SearchService,
              private router: Router, private route: ActivatedRoute) {
    this.ngOnInit();
  }

  ngOnInit(): void {
    // @ts-ignore
    const nonprofitDonorId: string = this.route.snapshot.paramMap.get('nonprofitDonorId');
    console.log('SearchGrantsDetailsComponent: ngOnInit: nonprofitDonorId: ' + nonprofitDonorId);
    // @ts-ignore
    const searchDto: NonprofitsDonorsDetailsSearchDto = {
      'nonprofitDonorId': parseInt(nonprofitDonorId),
      'taxYears': []
    }

    const username = localStorage.getItem('username');
    const browserUrl = window.location.href;
    if (browserUrl.includes('donors')) {
      // @ts-ignore
      this.searchService.getNonprofitDonorFullAttributes(parseInt(nonprofitDonorId), username).subscribe(
        (result : any) => {
          if (result && result.body) {
            this.nonprofitDonorFullAttr = result.body;
          }
        }, (err: HttpErrorResponse) => {
          console.log('err: ' + JSON.stringify(err));
        }
      );
      // @ts-ignore
      this.searchService.getDonorDetails(searchDto, nonprofitDonorId, username).subscribe((result: any) => {
        if (result && result.body) {
          this.companyFinancialsByYear = result.body;
        }
      }, (err: HttpErrorResponse) => {
        console.log('err: ' + JSON.stringify(err));
      });

    } else if (browserUrl.includes('nonprofits')) {
      // @ts-ignore
      this.searchService.getNonprofitDonorFullAttributes(parseInt(nonprofitDonorId), username).subscribe(
        (result : any) => {
          if (result && result.body) {
            this.nonprofitDonorFullAttr = result.body;
          }
        }, (err: HttpErrorResponse) => {
          console.log('err: ' + JSON.stringify(err));
        }
      );
      // @ts-ignore
      this.searchService.getNonprofitDetails(searchDto, nonprofitDonorId, username).subscribe((result: any) => {
        if (result && result.body) {
          this.companyFinancialsByYear = result.body;
        }
      }, (err: HttpErrorResponse) => {
        console.log('err: ' + JSON.stringify(err));
      });
    } else {
      //should never happen
    }
  }

  onBack() {
    console.log('nonprofitDonorFullAttr: '+ JSON.stringify(this.nonprofitDonorFullAttr));
    console.log('nonprofitDonorFullAttr.returnTypeCode.returnTypeCodeName: '+ this.nonprofitDonorFullAttr.returnTypeCode.returnTypeCodeName);
    if (this.nonprofitDonorFullAttr.returnTypeCode.returnTypeCodeName === '990PF') {
      //For Donors
      this.router.navigateByUrl(this.nonprofitDonorFullAttr.nonprofitDonorId ? 'app/search/donors' : 'home');
    } else {
      //Nonprofits
      this.router.navigateByUrl(this.nonprofitDonorFullAttr.nonprofitDonorId ? 'app/search/nonprofits' : 'home');
    }
  }

}
